'use es6';

import http from 'hub-http/clients/apiClient';
import formatCustomObjectTypes from 'reference-resolvers/formatters/formatCustomObjectTypes';
export const createGetInboundDbObjectTypesById = ({
  httpClient
}) => objectTypeIds => httpClient.get(`inbounddb-meta/v1/object-types/batch-get`, {
  query: {
    objectType: objectTypeIds
  }
}).then(formatCustomObjectTypes);
export const getInboundDbObjectTypesById = createGetInboundDbObjectTypesById({
  httpClient: http
});